import { useState } from "react";

const AddTask = ({ onAdd }) => {
  const [taskTitle, setText] = useState("");
  const [taskText, setDay] = useState("");
  const [taskImportant, setReminder] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();

    if (!taskTitle) {
      alert("Please add a task");
      return;
    }

    onAdd({ taskTitle, taskText, taskImportant });

    setText("");
    setDay("");
    setReminder(false);

    //close the task adding section
  };

  return (
    <form className="add-form" onSubmit={onSubmit}>
      <div className="form-control">
        <label>Title</label>
        <input type="text" placeholder="Add Title" value={taskTitle} onChange={(e) => setText(e.target.value)} />
      </div>
      <div className="form-control">
        <label>Description</label>
        <input type="text" placeholder="Add Description" value={taskText} onChange={(e) => setDay(e.target.value)} />
      </div>
      <div className="form-control form-control-check">
        <label>Set Reminder</label>
        <input
          type="checkbox"
          checked={taskImportant}
          value={taskImportant}
          onChange={(e) => setReminder(e.currentTarget.checked)}
        />
      </div>

      <input type="submit" value="Save Task" className="btn btn-block" />
    </form>
  );
};

export default AddTask;
